import { useCallback, useMemo, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import { ProductsSequenceProduct } from 'common/contracts';

export type ProductEntry = ProductsSequenceProduct & { id: string };

export const usePopupProducts = (isDailyBonus: boolean) => {
  const [dailyProducts, setDailyProducts] = useState<ProductEntry[]>([]);
  const [postProducts, setPostProducts] = useState<ProductEntry[]>([]);

  const productsList = useMemo(
    () => (isDailyBonus ? dailyProducts : postProducts),
    [isDailyBonus, dailyProducts, postProducts]
  );

  const addProduct = useCallback(
    (newProduct: ProductsSequenceProduct) => {
      const entry: ProductEntry = { ...newProduct, id: uuidv4() };
      if (isDailyBonus) {
        setDailyProducts((prev) => [...prev, entry]);
      } else {
        setPostProducts([entry]);
      }
    },
    [isDailyBonus]
  );

  const deleteProduct = useCallback(
    (id: string) => {
      if (isDailyBonus) {
        setDailyProducts((prev) => prev.filter((p) => p.id !== id));
      } else {
        setPostProducts((prev) => prev.filter((p) => p.id !== id));
      }
    },
    [isDailyBonus]
  );

  const updateProduct = useCallback(
    (id: string, newProductData: ProductsSequenceProduct) => {
      if (isDailyBonus) {
        setDailyProducts((prev) =>
          prev.map((p) =>
            p.id === id ? { ...p, ...newProductData } : p
          )
        );
      } else {
        setPostProducts((prev) =>
          prev.map((p) =>
            p.id === id ? { ...p, ...newProductData } : p
          )
        );
      }
    },
    [isDailyBonus]
  );

  return {
    productsList,
    addProduct,
    deleteProduct,
    updateProduct,
    setDailyProducts,
    setPostProducts
  };
};
